import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { SharedService } from '../../../shared/services/shared.service';
import { FinanciacionPropiaModel } from './financiacion-propia.model';
import { FinanciacionPropiaFormComponent } from './financiacion-propia-form.component';

@Component({
    selector: 'convfact-dialog-import-account-financiacion-propia',
    templateUrl: './financiacion-propia-dialog-importAccount.component.html',
    styleUrls: ['./financiacion-propia.component.css'],
    standalone: false
})
export class FinanciacionPropiaDialogImportAccount {

    dataImport: FinanciacionPropiaModel = this.data.dataImport;

    constructor(
        public dialogRef: MatDialogRef<FinanciacionPropiaFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        public sharedService: SharedService
    ) { }

    startImport() {
        this.sharedService.importAccountsUpdate(this.dataImport, "FinanciacionPropia").then(result => {
            this.dialogRef.close();
        });
    }

    closeDialog() {
        this.dialogRef.close();
    }




}
